import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { setAuthenticator } from '@ms/yammer-web-authenticators';
import type MsalRedirectAuthenticator from '@ms/yammer-web-authenticators/dist/redirect/MsalRedirectAuthenticator';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';

import config from '../config';
import { persistConfig } from '../persistedState';

import { reportAuthError } from './reportAuthError';

const getAuthenticator = async (): Promise<MsalRedirectAuthenticator> => {
  const networkContext = getNetworkContext(window.location.pathname);
  let tenant = config.msal.tenant;
  if (networkContext?.networkType === 'Canonical') {
    tenant = networkContext.permalink;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (config as any).adal = config.msal;
  const { default: MsalRedirectAuthenticator } = await import(
    /* webpackChunkName: "4-auth-msal" */ '@ms/yammer-web-authenticators/dist/redirect/MsalRedirectAuthenticator'
  );

  return new MsalRedirectAuthenticator({
    ...config.msal,
    tenant,
    onError: reportAuthError,
    isPairwiseBrokerEnabled: !!(await getPersistedExperimentTreatment(
      persistConfig.key,
      'EngagePairwiseBrokerHosting'
    )),
  });
};

export type SetupAuthenticator = () => ReturnType<typeof getAuthenticator>;
export const setupAuthenticator: SetupAuthenticator = async () => {
  const authenticator = await getAuthenticator();

  setAuthenticator(authenticator);

  return authenticator;
};
